module.exports = __webpack_public_path__ + "img/two_new.f93364af.png";